<template>
  <b-container fluid>
    <b-modal title="Nuevo Devengado" id="my-modal" body-bg-variant="dark" header-bg-variant="dark" footer-bg-variant="dark" size="md">
      <!-- <h4 class="px-4 py-4"><b>DEVENGADOS</b></h4> -->
      <div class="row px-5">
        <div class="col-md-12">
          <div class="mb-4">
            <p>Los devengados que creas aquí son los que te saldrán al momento de gestionar la nómina de tus empleados.</p>
            <label for=" " class="form-label mt-3">Tipo de devengado</label>
            <b-form-select required value-field="id" text-field="nombre" :options="listaDevengados"></b-form-select>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="submit" class="mx-1 btn px-4 py-2 btn-primary">Guardar Devengado</button>
          <button class="mx-1 btn px-4 py-2 btn-secondary" @click="$bvModal.hide('my-modal')">Cancelar</button>
        </div>
      </template>
    </b-modal>
    <b-row>
      <b-col sm="12">
        <card>
          <template v-slot:headerTitle>
            <h4 class="card-title"><b>NOMINAS</b></h4>
          </template>
          <div class="text-right px-4 mt-3">
            <!--   -->
            <!-- <b-button v-b-modal.my-modal @click="infoForPerson(item)">Ver más</b-button> -->
            <!-- <button v-b-modal.my-modal class="mx-1 btn btn-success"><i class="fas fa-plus"></i>Agregar Devengado</button> -->
          </div>
          <div class="table-responsive px-4 mt-3">
            <table id="datatable_nomina" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Mes</th>
                  <th>Empleados</th>
                  <th>Emitidos</th>
                  <th>Por emitir</th>
                  <th>Por corregir</th>
                  <th>Estado</th>
                  <th>Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in listaItems" :key="item.id">
                  <td>{{ item.mes }}</td>
                  <td>{{ item.empleados }}</td>
                  <td>{{ item.emitidos }}</td>
                  <td>{{ item.por_emitir }}</td>
                  <td>{{ item.por_corregir }}</td>
                  <td>{{ item.estado }}</td>
                  <td>
                    <span class="pointer"
                      ><i @click="$router.push('nomina_editar/' + item.id)" class="fas fa-solid fa-pen px-1 text-success"></i>
                      <!-- <i @click="deleteRow(item.id)" class="fas fa-solid fa-trash px-1 text-danger"></i> -->
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from "../../../../config/pluginInit";
const Swal = require("sweetalert2");

export default {
  name: "DataTable",
  data() {
    return {
      listaItems: [{
        id:1,
        mes:"Julio 2023",
        emitidos:0,
        empleados:5,
        por_emitir: 5,
        por_corregir:0,
        estado:"Por emitir",
      }],
      logoEmpresa: "",
      usuario: {},
      listaDevengados: [
        { id: 3, nombre: "Salario" },
        { id: 4, nombre: "Auxilio de transporte" },
        { id: 5, nombre: "Viáticos salariales" },
        { id: 6, nombre: "Viáticos no salariales" },
        { id: 7, nombre: "Horas extras diurnas" },
        { id: 8, nombre: "Horas extras nocturnas" },
        { id: 9, nombre: "Horas extras dominicales y festivas" },
        { id: 10, nombre: "Horas extras nocturnas dominicales y festivas" },
        { id: 11, nombre: "Horas recargo nocturno" },
        { id: 12, nombre: "Horas recargo dominical y festiva" },
        { id: 13, nombre: "Hora recargo nocturno dominical y festivos" },
        { id: 14, nombre: "Vacaciones disfrutadas" },
        { id: 15, nombre: "Vacaciones compensadas no disfrutadas" },
        { id: 16, nombre: "Prima salarial" },
        { id: 17, nombre: "Prima no salarial" },
        { id: 18, nombre: "Cesantías" },
        { id: 19, nombre: "Intereses cesantías" },
        { id: 20, nombre: "Incapacidad común" },
        { id: 21, nombre: "Incapacidad profesional" },
        { id: 22, nombre: "Incapacidad laboral" },
        { id: 23, nombre: "Licencia de maternidad o paternidad" },
        { id: 24, nombre: "Licencia remunerada" },
        { id: 25, nombre: "Licencia no remunerada" },
        { id: 26, nombre: "Bonificación salarial" },
        { id: 27, nombre: "Bonificación no salarial" },
        { id: 28, nombre: "Auxilio salarial" },
        { id: 29, nombre: "Auxilio no salarial" },
        { id: 30, nombre: "Huelga legal" },
        { id: 31, nombre: "Otro concepto salarial" },
        { id: 32, nombre: "Otro concepto no salarial" },
        { id: 33, nombre: "Compensación ordinaria" },
        { id: 34, nombre: "Compensación extraordinaria" },
        { id: 35, nombre: "Bono de alimentación salarial" },
        { id: 36, nombre: "Bono de alimentación no salarial" },
        { id: 37, nombre: "Otros bonos salariales" },
        { id: 38, nombre: "Otros bonos no salariales" },
        { id: 39, nombre: "Comisión" },
        { id: 40, nombre: "Pago a terceros" },
        { id: 41, nombre: "Anticipo" },
        { id: 42, nombre: "Dotación" },
        { id: 43, nombre: "Apoyo sostenimiento" },
        { id: 44, nombre: "Teletrabajo" },
        { id: 45, nombre: "Bonificación por retiro" },
        { id: 46, nombre: "Indemnización" },
        { id: 47, nombre: "Reintegro" },
      ],
    };
  },
  async mounted() {
    try {
      this.$isLoading(true);
      this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
      // await this.getData();
      core.index();
      window.$("#datatable_nomina").DataTable({
        language: {
          url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
        },
      });
      this.$isLoading(false);
    } catch (error) {
      this.$isLoading(false);
      console.log("error", error);
    }
  },
  methods: {
    async deleteRow(id) {
      Swal.fire({
        title: "Seguro eliminar registro?",
        text: "Después de eliminarlo no podrás recuperarlo!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si!",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          //let loader = this.$loading.show();
          await this.$store.dispatch("hl_get", {
            path: "Departamento/DeleteDepartamento/" + id,
          });

          //console.log("res", res);
          //loader.hide()
          await this.getData();

          Swal.fire("Listo!", "Registro eliminado correctamente.", "success");
        }
      });
    },
    async getData() {
      //console.log(this.persona.empresa.id);
      try {
        console.log("departamentoss.....................");
        let res = await this.$store.dispatch("hl_get", {
          path: "Departamento/ListDepartamento/" + this.usuario.empresa.id,
        });
        console.log("post departamento... ", res);
        if (res.length > 0) {
          this.listaItems = [];
          //   this.listaItems = res;
        } else {
          this.listaItems = [];
        }
      } catch (error) {
        this.listaItems = [];
        console.log("err", error);
      }
    },
  },
};
</script>
